export default __webpack_public_path__ + "static/media/PPI-patio-033.6da01917.jpg";